import React, { useState } from 'react';
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Typography,
    Box
} from '@mui/material';
import { connect, useDispatch } from 'react-redux';

// Services
import UserService from 'services/user.service';

//Hooks
import { useAuth } from 'contexts/AuthContext';

// Store actions
import { setActiveUserProperty } from 'store/actions/Properties';

// Components
import Loader from 'components/common/Loader';

const PropertySelector = () => {
    const { user, activeProperty, properties, refreshUser } = useAuth();

    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const handlePropertyChange = async event => {
        const selectedPropertyId = event.target.value;
        const currentActiveId = activeProperty.id;

        if (currentActiveId === selectedPropertyId) return;

        try {
            setLoading(true);

            await UserService.setActiveProperty(user?.uid, selectedPropertyId);

            const selectedProperty =
                (properties || []).find(p => p.id === selectedPropertyId) || null;

            if (selectedProperty) {
                dispatch(setActiveUserProperty(selectedProperty));
            }

            await refreshUser();
        } catch (error) {
            console.error('Error setting active property:', error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            {loading && <Loader />}
            <div>
                <FormControl fullWidth>
                    <InputLabel id="property-label">Select Property</InputLabel>
                    <Select
                        labelId="property-label"
                        id="property-select"
                        value={activeProperty.id}
                        onChange={handlePropertyChange}
                        label="Select Property"
                        style={{
                            height: 37.5,
                            width: 200,
                            textTransform: 'capitalize'
                        }}
                        variant="outlined"
                    >
                        {properties.map(property => (
                            <MenuItem key={property.id} value={property.id}>
                                {property?.address?.full_address ?? 'Unknown Address'}
                                &nbsp;&nbsp;
                                {property?.rental && (
                                    <Typography
                                        sx={{
                                            fontSize: '12px',
                                            borderRadius: '5px',
                                            paddingX: 1
                                        }}
                                        component="span"
                                        variant="body1"
                                        color="success.main"
                                        bgcolor="success.lighter"
                                    >
                                        Rental
                                    </Typography>
                                )}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                {loading && (
                    <Box
                        sx={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            bgcolor: 'rgba(255, 255, 255, 0.6)',
                            zIndex: 100,
                            pointerEvents: 'auto',
                            borderRadius: 1
                        }}
                    />
                )}
            </div>
        </>
    );
};

export default connect(null, {})(PropertySelector);
